import { useCallback, useState } from "react";
import { SESSION_ERROR_RESULTS } from "utils/patentDesign";

const DOWNLOAD_DELAY_MS = 300;

const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const saveBlob = (data, fileName) => {
  const blob = data instanceof Blob ? data : new Blob([data]);
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

const usePatentDesignDownload = ({ onAlert, onError }) => {
  const [isDownloading, setIsDownloading] = useState(false);

  const download = useCallback(
    async (files, fetchFile) => {
      if (!files.length) return;
      setIsDownloading(true);
      const failed = [];
      try {
        for (let i = 0; i < files.length; i++) {
          const file = files[i];
          try {
            const result = await fetchFile(file.id);
            if (result?.data instanceof Blob) {
              saveBlob(result.data, file.name);
            } else if (SESSION_ERROR_RESULTS.includes(result)) {
              onError(result);
              return;
            } else {
              failed.push(file.name);
            }
          } catch {
            failed.push(file.name);
          }
          if (i < files.length - 1) await wait(DOWNLOAD_DELAY_MS);
        }
      } finally {
        setIsDownloading(false);
      }
      if (failed.length) {
        onAlert(`다운로드하지 못한 파일이 있습니다.\n${failed.join("\n")}`);
      }
    },
    [onAlert, onError]
  );

  return { isDownloading, download };
};

export default usePatentDesignDownload;
